// @internal
export const getInitialEntitiesState = () => ({
  entities: {},
  ids: [],
  loading: true,
  error: null
});
